export const mapToNumeric = value => ((value || '') + '').replace(/\D/g, '')

export const masker = (mask, value, TOKEN_CHAR = '#') => {
  if (!value) return ''

  const inputLeft = String(value).replace(/\D/g, '').split('')

  return mask.split('')
    .map(char => char === TOKEN_CHAR ? inputLeft.shift() : char)
    .join('')
}
